import React from "react";

//Layouts
import NonAuthLayout from "../Layouts/NonAuthLayout";
import VerticalLayout from "../Layouts/index";

import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { useLocation } from "react-router-dom";

//routes
import { authProtectedRoutes, publicRoutes } from "./allRoutes";
import { AuthProtected } from "./AuthProtected";

const Index = () => {
  const location = useLocation();

  const availablePublicRoutesPaths = publicRoutes.map((r) => r.path);

  console.log(availablePublicRoutesPaths, location?.pathname?.split("-")[0], "PUBLICC__ROUTBES");

  return (
    <React.Fragment>
      {availablePublicRoutesPaths.includes(location?.pathname) ||
        location?.pathname?.split("-")[0] === "/reset" ||
        location?.pathname?.split("/")[1] === "pay" ||
        location?.pathname?.split("-")[0] === "/cf" ? null : (
        <VerticalLayout>
          <Routes>
            <Route element={<AuthProtected />}>
              {authProtectedRoutes.map((route, idx) => {
                return <Route path={route.path} element={route.component} key={idx} exact={true} />;
              })}
            </Route>
          </Routes>
        </VerticalLayout>
      )}

      <NonAuthLayout>
        <Routes>
          {publicRoutes.map((route, idx) => (
            <Route path={route.path} element={route.component} key={idx} exact={true} />
          ))}
        </Routes>
      </NonAuthLayout>

    </React.Fragment>
  );
};

export default Index;
